<template>
    <div class="flex flex-wrap justify-center md:justify-evenly my-7">
        <a href="#"
            class="block md:mb-0 mb-2 h-fit bg-till-date max-w-sm p-3 w-[300px]   border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
                <h6 class="mb-2 text-[15px]   font-family-card    tracking-tight text-white dark:text-white">Till Date</h6>
                <h6 class="font-family-card text-[15px]  text-white">(KG's)</h6>
            </div>
            <div
                class="font-family-card    border-dotted border-b-2 flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Collected</h1>
                <h1 class="text-sm"> {{ formatNumber(cardData.tillDateCollectionCount) }}</h1>
            </div>
            <div class="font-family-card   flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="pt-2 text-xs">Disposed</h1>
                <h1 class="pt-2 text-sm"> {{ formatNumber(cardData.tillDateIncinerationCount) }}</h1>
            </div>
        </a>
        <a href="#"
            class="block  h-fit bg-current-year max-w-sm p-3 w-[300px] md:w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
                <h6 class="mb-2 font-family-card    text-[15px] tracking-tight text-white dark:text-white">Current Year</h6>
                <h6 class="font-family-card text-[15px]  text-white">(KG's)</h6>
            </div>
            <div
                class="font-family-card    border-dotted border-b-2 flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Collected</h1>
                <h1 class="text-sm"> {{ formatNumber(cardData.currentYearCollectionCount) }}</h1>
            </div>
            <div class="font-family-card   flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="pt-2 text-xs">Disposed</h1>
                <h1 class="pt-2 text-sm"> {{ formatNumber(cardData.currentYearIncinerationCount) }}</h1>
            </div>
        </a>
    </div>
    <div class="flex flex-wrap justify-evenly my-7">
        <a href="#"
            class="block md:mb-0 mb-5 h-fit bg-current-month max-w-sm p-3 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
                <h6 class="mb-2 font-family-card    text-[15px] tracking-tight text-white dark:text-white">Current Month</h6>
                <h6 class="font-family-card text-[15px]  text-white">(KG's)</h6>
            </div>

            <div
                class="font-family-card   border-dotted border-b-2 flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Collected</h1>
                <h1 class="text-sm"> {{ formatNumber(cardData.currentMonthCollectionCount) }}</h1>
            </div>
            <div class="font-family-card   flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="pt-2 text-xs">Disposed
                </h1>
                <h1 class="pt-2 text-sm">{{ formatNumber(cardData.currentMonthIncinerationCount) }}</h1>
            </div>
        </a>
        <a href="#"
            class="block  h-fit bg-current-week max-w-sm p-3 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
                <h6 class="mb-2 font-family-card    text-[15px] tracking-tight text-white dark:text-white">Current Week</h6>
                <h6 class="font-family-card text-[15px]  text-white">(KG's)</h6>
            </div>
            <div
                class="font-family-card   border-dotted border-b-2 flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Collected</h1>
                <h1 class="text-sm"> {{ formatNumber(cardData.currentWeekCollectionCount) }}</h1>
            </div>
            <div class="font-family-card   flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="pt-2 text-xs">Disposed</h1>
                <h1 class="pt-2 text-sm"> {{ formatNumber(cardData.currentWeekIncinerationCount) }}</h1>
            </div>
        </a>
    </div>
    <div class="flex flex-wrap justify-evenly mt-6 my-7">
        <a href="#"
            class="block md:mb-0 mb-5 h-fit bg-current-day max-w-sm p-3 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
                <h6 class="mb-2 font-family-card    text-[15px] tracking-tight text-white dark:text-white">Current Day</h6>
                <h6 class="font-family-card   text-white">(KG's)</h6>

            </div>
            <div
                class="font-family-card   border-dotted border-b-2 flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="text-xs">Collected</h1>
                <h1 class="text-sm"> {{ formatNumber(cardData.currentDateCollectionCount) }}</h1>
            </div>
            <div class="font-family-card   flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="pt-2 text-xs">Disposed</h1>
                <h1 class="pt-2 text-sm"> {{ formatNumber(cardData.currentDateIncinerationCount) }}</h1>
            </div>
        </a>
        <a href="#"
            class="block  h-fit bg-till-date-progress max-w-sm p-3 w-[300px]   border border-gray-200 rounded-lg shadow  dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
            <div class="flex justify-between">
                <h6 class="mb-2 font-family-card    text-[15px] tracking-tight text-white dark:text-white">Till Date - Progress
                </h6>
                <h6 class="font-family-card text-[15px]  text-white">(KG's)</h6>

            </div>
            <div
                class="font-family-card   pb-4 border-dotted  flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1 class="pt-3 text-xs">Collected</h1>
                <h1 class="pt-3 text-sm"> {{ formatNumber(cardData.tillDateInProcessCollectionCount) }}</h1>
            </div>
            <!-- <div class="font-family-card   flex flex-wrap justify-between text-white dark:text-gray-400">
                <h1>Disposed</h1>
                <h1> {{ cardData.tillDateIncinerationCount }}</h1>
            </div> -->
        </a>
    </div>
</template>
<script setup>
import { defineProps } from 'vue';

// Define the props to be received
const props = defineProps(['cardData']);

const formatNumber = (value) => {
    if (value !== undefined) {
        return value.toLocaleString();
    } else {
        return 0;
    }
};
</script>
<style>
.font-family-card {
    font-family: Nunito Sans
}
</style>
